<template>
  <div class="site__body">
    <div class="block-header block-header--has-breadcrumb block-header--has-title">
      <div class="container">
        <div class="block-header__body">
          <div class="flexbox-page-info-container">
            
            <div class="flex-item-page-info-breadcrumbs">
                <nav class="breadcrumb block-header__breadcrumb" aria-label="breadcrumb">
                    <ol class="breadcrumb__list">
                      <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                      <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                        <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                      </li>
                      <li class="breadcrumb__item breadcrumb__item--current" aria-current="page">
                        <router-link to="/category" class="breadcrumb__item-link">Categories</router-link>
                      </li>

                      <li class="breadcrumb__item breadcrumb__item--current" v-for="(catbr, i) in categories_breadcrumb" 
                        aria-current="page"
                        :key="i">
                        <router-link :to="catbr.uri" class="breadcrumb__item-link">{{catbr.title}}</router-link>
                      </li>
                      <li class="breadcrumb__title-safe-area" role="presentation"></li>
                    </ol>
                </nav>
            </div>

            <div class="flex-item-page-info-title">
              <h1 class="block-header__breadcrumb-slim">
                {{category_name}}
              </h1>
            </div>
            
            <base-selected-vehicle></base-selected-vehicle>
          </div>
        </div>
      </div>
      <div class="container">
        <active-vehicle v-if="has_search_vehicle == true"></active-vehicle>
      </div>
    </div>

    <div class="block block-split block-split--has-sidebar">
      <div class="container">
        <div class="block-split__row row no-gutters">
          <div class="block-split__item block-split__item-sidebar col-auto">
            <product-categories v-if="cat_grid === true"></product-categories>
            <faceted-panel
              ref="faceted_panel"
              :level="level"
              :categoryUri1="categoryUri1"
              @view_parts="view_parts"
              @filter_changed="filter_changed"></faceted-panel>
              
            <latest-products></latest-products>
          </div>
          <div class="block-split__item block-split__item-content col-auto">
            <category-drill-down-grid v-if="cat_grid === true"></category-drill-down-grid>
            <page-display-options-search
              v-if="cat_grid === false"
              @changePerPage="changePerPage"
              searchTerm="By Category"
              :total_results="total_results"
              @filterPrice="filterPrice"
              @filterAvailability="filterAvailability"
              @removeFilter="removeFilter"
              @clearAll="clearAll"
              ref="display_options"
            ></page-display-options-search>
            
            <result-list
              v-if="cat_grid === false"
              ref="result_list"
              @total_items="total_items"
              :perPage="perPage"
              :currentPage="page"
              :filter_price="filter_price"
              :filter_availability="filter_availability"
              :keyword="keyword"
              :level="level"
              :categoryUri1="categoryUri1"
              @total_showing="total_showing"
              @show_messages="show_messages"
              @isKit="kit_catalog"
              @facet_keys="facet_keys"
            ></result-list>

            <div class="products-view__pagination" v-if="cat_grid === false">
              <nav class="Page navigation example">
                <base-pagination
                  :perPage="perPage"
                  :pages="pages"
                  :currentPage="page"
                  @updatePage="updatePage"
                ></base-pagination>
              </nav>
              <div class="products-view__pagination-legend">
                <!-- Showing {{ page + '-' +  showing }} of {{ total_results }} products -->
                Showing {{ showing_page }} of {{ total_results }} products
              </div>
            </div>
          </div>
        </div>
        <div class="block-space block-space--layout--before-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import FacetedPanel from "../category/FacetedPanel";
import LatestProducts from '../productdetail/LatestProducts';
import ProductCategories from '../productdetail/ProductCategories';
import ActiveVehicle from '../../common/vehicle/ActiveVehicle';
import CategoryDrillDownGrid from "./CategoryDrilldownGrid";
import ResultList from "../categorysearch/ResultList";
import PageDisplayOptionsSearch from "../categorysearch/PageDisplayOptionsSearch";
import BasePagination from "../../base/BasePagination.vue";
// import { sfCustom } from '../../../utilities/customs';
import { mapGetters } from 'vuex';

export default {
  name: "CategoryDrilldown",
  components: {
    LatestProducts,
    ProductCategories,
    ActiveVehicle,
    CategoryDrillDownGrid,
    FacetedPanel,
    ResultList,
    PageDisplayOptionsSearch,
    BasePagination
  },
  props: {
    level: {
      type: String,
      required: true
    },
    categoryUri1: {
      type: String
    },
    categoryUri2: {
      type: String
    },
    categoryUri3: {
        type: String
    },
    categoryUri4: {
        type: String
    },
    categoryUri5: {
        type: String
    },
    categoryUri6: {
        type: String
    },
    categoryUri7: {
        type: String
    },
    categoryUri8: {
        type: String
    },
    categoryUri9: {
        type: String
    },
  },
  data() {
    return {
      cat_grid: true,
      to_reloadlist: null,
      categories_breadcrumb: [],

      category_name: 'Categories',
      category_lvl1_name: '',
      category_lvl1_to: '',
      category_lvl2_name: '',
      category_lvl2_to: '',
      category_lvl3_name: '',
      category_lvl3_to: '',

      page: 1,
      perPage: 10,
      pages: [],
      total_results: 0,
      showing: 0,

      facet_filters: {},
      selected_filter: {},
      filter_price: '',

      // search_vehicle: false,
    };
  },

  computed: {
    ...mapGetters([
      "storefront"
    ]),
    has_search_vehicle() {
        if(this.storefront){
            // return sfCustom[this.storefront].search_vehicle;
            return process.env.VUE_SEARCH_VEHICLE;
        }
        return false;
    },

    /**show pages */
    showing_page() {
      let pagesShowing = '';
      let pg = this.page - 1;
      let startpg = pg * this.perPage;
      let endpg = '';
      if(startpg == 0){
        startpg = 1;
      }else{
        startpg += 1;
      }

      if(this.total_results < (this.page * this.perPage)){
        endpg = this.total_results;
      }else{
        endpg = this.page * this.perPage;
      }

      pagesShowing += startpg + '-' + endpg;

      return pagesShowing;
    }
  },

  methods: {
    view_parts(changed) {
      this.cat_grid = false;
      this.filter_changed(changed);
    },

    getParent() {
      const level = this.$route.params.level;
      const code = this.$route.params.categoryUri;
      const categories = this.$store.getters['product/categories'];
      let category_level;

      if(level == 1){
          category_level = categories.find((cat) => ((cat.DMCD01 === code) && (cat.categorylevel === 1)));
          this.category_name = category_level.categoryname;
          this.category_lvl1_name = this.category_name;
          this.category_lvl1_to = '/category/1/' + code;
          this.category_lvl2_name = '';
          this.category_lvl3_name = '';
      }else if(level == 2){
          category_level = categories.find((cat) => ((cat.DMCD02 === code) && (cat.categorylevel === 2)));
          
          this.category_name = category_level.categoryname;
          this.category_lvl2_name = this.category_name;
          this.category_lvl2_to = '/category/2/' + code;

          // build level 1 name and link
          const category_level1 = categories.find((cat) => ((cat.DMCD01 === category_level.DMCD01) && (cat.categorylevel === 1)));
          console.log(category_level1);
          this.category_lvl1_name = category_level1.categoryname;
          this.category_lvl1_to = '/category/1/' + category_level1.DMCD01;
          
      }else if(level == 3){
          category_level = categories.find((cat) => ((cat.DMCD03 === code) && (cat.categorylevel === 3)));
          this.category_name = category_level.categoryname;
          this.category_lvl3_name = this.category_name;
          this.category_lvl3_to = '/category/3/' + code;

          // build level 1 name and link
          const category_level2 = categories.find((cat) => ((cat.DMCD02 === category_level.DMCD02) && (cat.categorylevel === 2)));
          this.category_lvl2_name = category_level2.categoryname;
          this.category_lvl2_to = '/category/2/' + category_level2.DMCD02;

          // build level 1 name and link
          const category_level1 = categories.find((cat) => ((cat.DMCD01 === category_level.DMCD01) && (cat.categorylevel === 1)));
          this.category_lvl1_name = category_level1.categoryname;
          this.category_lvl1_to = '/category/1/' + category_level1.DMCD01;
      }
    },

    /**
     * build page bread crumbs
     */
    buildBreadCrumbs() {
      const level = this.$route.params.level;
      const categories = this.$store.getters['product/categories'];
      let lvl = 1;
      let currentcategory = categories.filter((cat) => (cat['DMCD0' + level] == this.$route.params['categoryUri' + level] && cat.categorylevel == level));

      while(lvl <= level){
        if(lvl < 10){
            l = '0' + lvl;
        }else{
            l = lvl;
        }
        currentcategory = currentcategory.filter((cat) => cat['DMCD' + l] == this.$route.params['categoryUri' + lvl]);
        lvl++;
      }

      // if current category not found
       // redirect to 404 page
      if (currentcategory == undefined){
        this.$router.push('/404');
        return;
      }else{
        currentcategory = currentcategory[0];
      }
      
      this.category_name = currentcategory.categoryname;

      let category;
      lvl = 1;
      let uris = '';
      let cat_uri = '';
      let l = '';
      this.categories_breadcrumb = [];
      
      while(lvl <= level){
        category = categories.find((cat) => (cat['DMCD0' + lvl] == this.$route.params['categoryUri' + lvl] && cat.categorylevel == lvl));
        if (category != undefined){
          cat_uri += '/' + category['DMCD0' + lvl];
          uris = '/category/' + lvl + cat_uri;
          this.categories_breadcrumb.push({
            title : category.categoryname,
            uri   : uris,
            level : lvl
          });
        }
        lvl++;
      }

      this.categories_breadcrumb.forEach(b => {
        lvl = 1;
        while(lvl <= b.level){
          l = lvl;
          if(lvl < 10){
            l = '0' + lvl;
          }
          category = categories.find((cat) => (cat['DMCD' + l] == this.$route.params['categoryUri' + lvl] && cat.categorylevel == lvl));
          b.uri += '/' + category.categoryname.replace(/ /g, '-');
          lvl++;
        }
      });

    },

    /**
     * filter changed from faceted filter
     * @param {*} changed 
     */
    filter_changed(changed) {
      if (this.cat_grid === false){
        clearTimeout(this.to_reloadlist);
        
        this.to_reloadlist = setTimeout(() => {
          this.selected_filter = changed;
          this.$refs.result_list.solr_search(changed);
        },500);

      }
    },


    total_items(total) {
      // console.log('total = ' + total);
      this.total_results = total;
      this.pages = [];
      let numberOfPages = Math.ceil(this.total_results / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
      // console.log(this.pages);
    },

    total_showing(total) {
      this.showing = total;
    },

    updatePage(currentPage) {
      this.page = currentPage;
      this.$refs.result_list.solr_search(this.selected_filter, this.page);
    },

    changePerPage(newPerPage) {
      this.page = 1;
      this.perPage = newPerPage;
      this.total_items(this.total_results);
    },

    facet_keys(facet){
      // console.log(facet);
      this.facet_filters = facet;
      // this.$refs.search_filter.rebuildFilter(facet);

      // display active filter
      if (this.cat_grid === false){
        this.$refs.display_options.filter_changed(this.selected_filter, facet);
      }
    },

    // remove filter from the page display options / active filter section
    removeFilter(f) {
        this.$refs.faceted_panel.removeFilter(f[0]);
    },

    // clear all from the page display options / active filter section
    clearAll() {
        this.$refs.faceted_panel.removeFilter('all');
    },
    filterPrice(fval) {
      this.filter_price = fval;
    },

  },
  created() {
    // this.search_vehicle = sfCustom[this.storefront].search_vehicle;
    this.buildBreadCrumbs();

  },
  updated() {

  },
  watch: {
    level() {
      this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
      });
      this.selected_filter = {};
      this.buildBreadCrumbs();
      this.filter_changed();
    },
    categoryUri1() {
      this.selected_filter = {};
      this.cat_grid = true;
    },
  }
};
</script>
